import z from 'zod';
import { DisplayData, DistanceAddressSchema } from '~/lib/model';
import {
  coerceBoolean,
  coerceLiteralNumberRequired,
  FIRST_VERSION_TIMESTAMP,
  zodTMoneyOptional,
  ZodVersionedMetadata
} from '~/lib/zod';
import { TenantCustomer } from '~/tenants/common/TenantPersona';

export type BreCustomerMetadata = ZodVersionedMetadata<typeof BreCustomerSchema>;

export const BreCustomerSchema = {
  [FIRST_VERSION_TIMESTAMP]: z.object({
    version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    office: DistanceAddressSchema.optional(),
    home: DistanceAddressSchema.optional(),
    internal_notes: z.string().optional(),
    hold_reason: z.string().optional(),
    free_floorplan: coerceBoolean().optional(),
    free_cinematic_aerial: coerceBoolean().optional(),
    override_cinematic_under_3000: zodTMoneyOptional(),
    override_cinematic_over_3000: zodTMoneyOptional(),
  }),
};

export default class BreCustomer extends TenantCustomer<BreCustomerMetadata> {
  get info(): DisplayData[] {
    const info = super.info;

    if (this.metadata.internal_notes) {
      info.push({
        name: 'Internal Notes',
        value: this.metadata.internal_notes,
        provider: true,
      });
    }

    if (this.metadata.hold_reason) {
      info.push({
        name: 'Hold Reason',
        value: this.metadata.hold_reason,
        schedule: true,
      });
    }

    return info;
  }
}
